module.exports = __webpack_public_path__ + "static/img/login01_05.90dd843.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/login01_05.png
// module id = 4TPd
// module chunks = 0